import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from "react";
import { Message } from "./Message";
var defaultState = {
  top: [],
  "top-left": [],
  "top-right": [],
  "bottom-left": [],
  bottom: [],
  "bottom-right": []
};

var ToastManager = /*#__PURE__*/function (_React$Component) {
  _inherits(ToastManager, _React$Component);

  var _super = _createSuper(ToastManager);

  function ToastManager(props) {
    var _this;

    _classCallCheck(this, ToastManager);

    _this = _super.call(this, props);
    _this.state = defaultState;

    _this.notify = function (message, options) {
      var toast = _this.createToastState(message, options);

      var position = toast.position; // prepend the toast for toasts positioned at the top of
      // the screen, otherwise append it.

      var isTop = position.includes("top");

      _this.setState(function (prev) {
        return Object.assign({}, prev, _defineProperty({}, position, isTop ? [toast].concat(_toConsumableArray(prev[position])) : [].concat(_toConsumableArray(prev[position]), [toast])));
      });

      return {
        id: toast.id,
        position: toast.position
      };
    };

    _this.closeAll = function () {
      Object.keys(_this.state).forEach(function (pos) {
        var p = pos;
        var position = _this.state[p];
        position.forEach(function (toast) {
          _this.closeToast(toast.id, p);
        });
      });
    };

    _this.createToastState = function (message, options) {
      var id = ++ToastManager.idCounter; // a bit messy, but object.position returns a number because
      // it's a method argument.

      var position = options.hasOwnProperty("position") && typeof options.position === "string" ? options.position : "top";
      return {
        id: id,
        message: message,
        position: position,
        showing: true,
        duration: typeof options.duration === "undefined" ? 5000 : options.duration,
        onRequestRemove: function onRequestRemove() {
          return _this.removeToast(String(id), position);
        },
        type: options.type
      };
    };

    _this.closeToast = function (id, position) {
      _this.setState(function (prev) {
        return Object.assign({}, prev, _defineProperty({}, position, prev[position].map(function (toast) {
          if (toast.id !== id) return toast;
          return Object.assign({}, toast, {
            requestClose: true
          });
        })));
      });
    }; // actually fully remove the toast


    _this.removeToast = function (id, position) {
      _this.setState(function (prev) {
        return Object.assign({}, prev, _defineProperty({}, position, prev[position].filter(function (toast) {
          return toast.id !== id;
        })));
      });
    };

    _this.getStyle = function (position) {
      var style = {
        maxWidth: "560px",
        position: "fixed",
        zIndex: 5500,
        pointerEvents: "none"
      };

      if (position === "top" || position === "bottom") {
        style.margin = "0 auto";
        style.textAlign = "center";
      }

      if (position.includes("top")) {
        style.top = 0;
      }

      if (position.includes("bottom")) {
        style.bottom = 0;
      }

      if (!position.includes("left")) {
        style.right = 0;
      }

      if (!position.includes("right")) {
        style.left = 0;
      }

      return style;
    };

    props.notify(_this.notify, _this.closeAll, _this.closeToast);
    return _this;
  }

  _createClass(ToastManager, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return Object.keys(this.state).map(function (position) {
        var pos = position;
        var toasts = _this2.state[pos];
        return React.createElement("span", {
          key: position,
          className: "Toaster__manager-" + pos,
          style: _this2.getStyle(pos)
        }, toasts.map(function (toast) {
          return React.createElement(Message, Object.assign({
            position: pos,
            key: toast.id
          }, toast));
        }));
      });
    }
  }]);

  return ToastManager;
}(React.Component);

export { ToastManager as default };
ToastManager.idCounter = 0;